import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { TableCellComponent } from '@pct-ng/feature-table-material';
import type { Mapping } from './create-colored-column';
import { ResolveTranslateAbleTextPipe } from '@pct-ng/i18n';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cappus-status-cell-component',
  templateUrl: './colored-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block min-w-[50px] max-w-[50px]',
  },
  imports: [NgClass, ResolveTranslateAbleTextPipe],
})
export class ColoredCellComponent<T> implements TableCellComponent<T, any, Mapping> {
  readonly rowItem = input.required<T>();
  readonly value = input.required<any>();
  readonly params = input.required<Mapping>();
  protected readonly result = computed(() => this.params().mapping(this.value()));
}
